import { AlertCircle, TrendingUp, TrendingDown } from 'lucide-react';

/**
 * Returns the appropriate icon for severity level
 * @param severity - The severity level (critical, high, medium, low)
 * @returns JSX Element representing the icon
 */
export const getSeverityIcon = (severity: string): JSX.Element => {
  if (!severity) return <AlertCircle size={16} />;

  switch (severity.toLowerCase()) {
    case 'critical':
    case 'high':
      return <TrendingUp size={16} />;
    case 'medium':
    case 'low':
      return <TrendingDown size={16} />;
    default:
      return <AlertCircle size={16} />;
  }
};
